import React from "react";
import { ButtonGroup, Button } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

const SomaPlaceButtonGroup = (props) => {
  return (
    <ButtonGroup size="small" color="secondary" variant="outlined">
      <Button
        onClick={async () => {
          props.setContract(props.line.contract);
          props.setShowContrato(true);
        }}
      >
        <VisibilityIcon></VisibilityIcon>
      </Button>

      {/* <Button onClick={
      console.log('treta')
    }>
        <EditIcon></EditIcon>
    </Button> */}
    </ButtonGroup>
  );
};

export default SomaPlaceButtonGroup;
